module.exports = __webpack_public_path__ + "img/card-small-b5.a64c96e2.png";